import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CommonLibModule } from '@nrwl/common-lib';
import { CommonMaterialModule } from '@nrwl/common-material';
import { BreadcrumbActionsTimepickerComponent } from './breadcrumb-actions-timepicker/breadcrumb-actions-timepicker.component';
import { TestInfoActionsComponent } from './test-info-actions/test-info-actions.component';
@NgModule({
  imports: [CommonModule, CommonLibModule, CommonMaterialModule],
  declarations: [BreadcrumbActionsTimepickerComponent, TestInfoActionsComponent],
  exports: [BreadcrumbActionsTimepickerComponent]
})
export class BreadcrumbActionsTimepickerModule {}
